import { createSelector } from 'reselect';
import { Map } from 'immutable';
import getModuleStateSelector from './getModuleStateSelectors';

export const getMembersProducts = createSelector(
  getModuleStateSelector,
  (moduleState) => moduleState.get('products')
);

export const getMembersProductsList = createSelector(
  getMembersProducts,
  (products) => {
    if (!products) {
      return {};
    }
    return products.getIn(['types', 'CARD_PRODUCT', 'productsList'], Map()).toJS();
  }
);
